module.exports = __webpack_public_path__ + "img/img-acs.5ab925fb.png";